export function canAccess(user, resource) {
  // user may not have loaded yet
  const purchaseOrderIds = user ? user.purchaseOrders : [];
  let accessible = false;

  // Items that are added to purchase orders (purchasables) get sent from
  // the api with a unlockedBy property. This represents an array of purchase
  // order ids that unlock the purchasable item. We can loop through the purchase
  // orders that a user has and compare the id of that purchase order to the
  // array of purchase orders in unlockedBy. If the loop finds a purchase order id
  // in the unlockedBy array, the loop breaks and we return true signifying that
  // the user has access to the item.

  for (const purchaseOrderId of purchaseOrderIds) {
    const includedInPO = resource?.unlockedBy?.includes(purchaseOrderId);
    if (includedInPO) {
      accessible = true;
      break;
    }
  }

  return accessible;
}

export function includedInPaidPurchaseOrders(store, resource = {}) {
  const nonFreeUnlockingPurchaseOrders = [];
  for (const poId of (resource.unlockedBy || [])) {
    const po = store.getters['purchaseOrders/get'][poId];
    if (po && !po.isFree) {
      nonFreeUnlockingPurchaseOrders.push(po.id);
    }
  }

  return store.getters['purchaseReceipts/active'].some((purchaseReceipt) =>
    nonFreeUnlockingPurchaseOrders.includes(purchaseReceipt.purchaseOrderId)
  );
}

export function canAccessFeature(store, featureName) {
  return store.getters['purchaseReceipts/active'].some((purchaseReceipt) => {
    const po = store.getters['purchaseOrders/get'][purchaseReceipt.purchaseOrderId];
    return po?.features.includes(featureName);
  });
}

export const PAID_FEATURES = {
  PAID_RATIONALES: 'Paid Rationales',
  ADVANCED_FLASHCARD_STATS: 'Advanced Flashcard Stats',
  POSSIBILITY_OF_PASSING: 'Possibility of Passing',
  CUSTOM_QUIZZES: 'Custom Quizzes',
  PLANNING_ENGINE: 'Planning Engine',
  PROGRESS: 'Progress',
};
